import {
    GET_ALL_CREDIT_POLICIES_BEGIN, GET_ALL_CREDIT_POLICIES_SUCCESS, GET_ALL_CREDIT_POLICIES_FAILURE,
    GET_CREDIT_POLICY_BEGIN, GET_CREDIT_POLICY_SUCCESS, GET_CREDIT_POLICY_FAILURE,
    POST_CREDIT_POLICY_BEGIN, POST_CREDIT_POLICY_SUCCESS, POST_CREDIT_POLICY_FAILURE,
    PUT_CREDIT_POLICY_BEGIN, PUT_CREDIT_POLICY_SUCCESS, PUT_CREDIT_POLICY_FAILURE,
    ACTIVATE_CREDIT_POLICY_BEGIN, ACTIVATE_CREDIT_POLICY_SUCCESS, ACTIVATE_CREDIT_POLICY_FAILURE,
    DELETE_CREDIT_POLICY_BEGIN, DELETE_CREDIT_POLICY_SUCCESS, DELETE_CREDIT_POLICY_FAILURE
} from '../constants/ActionTypes'

const initialState = {

    // Get All Credit Policies
    allCreditPolicies: null,
    isLoadingAllCreditPolicies: false,
    hasErrorAllCreditPolicies: null,

    // Get Credit Policy
    selectedCreditPolicy: null,
    isLoadingSelectedCreditPolicy: false,
    hasErrorSelectedCreditPolicy: null,

    // Post Credit Policy
    createdCreditPolicy: null,
    isCreatingCreditPolicy: false,
    hasErrorCreatedCreditPolicy: null,

    // Put Credit Policy
    updatedCreditPolicy: null,
    isUpdatingCreditPolicy: false,
    hasErrorUpdatedCreditPolicy: null,

    // Activate Credit Policy
    activatedCreditPolicy: null,
    isActivatingCreditPolicy: false,
    hasErrorActivatedCreditPolicy: null,

    // Delete Credit Policy
    deletedCreditPolicy: null,
    isDeletingCreditPolicy: false,
    hasErrorDeletedCreditPolicy: null
}

/**
 * @description Reducer function for managing the state of credit policies.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the credit policies.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The updated state of the credit policies.
 */
const ReducerCreditPolicy = (state = initialState, action) => {
    switch (action.type) {

        // Get All Credit Policies
        case GET_ALL_CREDIT_POLICIES_BEGIN: {
            return {
                ...state,
                isLoadingAllCreditPolicies: true
            }
        }
        case GET_ALL_CREDIT_POLICIES_SUCCESS: {
            return {
                ...state,
                allCreditPolicies: action.payload,
                isLoadingAllCreditPolicies: false,
                hasErrorAllCreditPolicies: null
            }
        }
        case GET_ALL_CREDIT_POLICIES_FAILURE: {
            return {
                ...state,
                allCreditPolicies: null,
                isLoadingAllCreditPolicies: false,
                hasErrorAllCreditPolicies: action.payload
            }
        }

        // Get Credit Policy
        case GET_CREDIT_POLICY_BEGIN: {
            return {
                ...state,
                isLoadingSelectedCreditPolicy: true
            }
        }
        case GET_CREDIT_POLICY_SUCCESS: {
            return {
                ...state,
                selectedCreditPolicy: action.payload,
                isLoadingSelectedCreditPolicy: false,
                hasErrorSelectedCreditPolicy: null
            }
        }
        case GET_CREDIT_POLICY_FAILURE: {
            return {
                ...state,
                selectedCreditPolicy: null,
                isLoadingSelectedCreditPolicy: false,
                hasErrorSelectedCreditPolicy: action.payload
            }
        }

        // Post Credit Policy
        case POST_CREDIT_POLICY_BEGIN: {
            return {
                ...state,
                isCreatingCreditPolicy: true
            }
        }
        case POST_CREDIT_POLICY_SUCCESS: {
            return {
                ...state,
                createdCreditPolicy: action.payload,
                isCreatingCreditPolicy: false,
                hasErrorCreatedCreditPolicy: null
            }
        }
        case POST_CREDIT_POLICY_FAILURE: {
            return {
                ...state,
                createdCreditPolicy: null,
                isCreatingCreditPolicy: false,
                hasErrorCreatedCreditPolicy: action.payload
            }
        }

        // Put Credit Policy
        case PUT_CREDIT_POLICY_BEGIN: {
            return {
                ...state,
                isUpdatingCreditPolicy: true
            }
        }
        case PUT_CREDIT_POLICY_SUCCESS: {
            return {
                ...state,
                updatedCreditPolicy: action.payload,
                isUpdatingCreditPolicy: false,
                hasErrorUpdatedCreditPolicy: null
            }
        }
        case PUT_CREDIT_POLICY_FAILURE: {
            return {
                ...state,
                updatedCreditPolicy: null,
                isUpdatingCreditPolicy: false,
                hasErrorUpdatedCreditPolicy: action.payload
            }
        }

        // Activate Credit Policy
        case ACTIVATE_CREDIT_POLICY_BEGIN: {
            return {
                ...state,
                isUpdatingCreditPolicy: true
            }
        }
        case ACTIVATE_CREDIT_POLICY_SUCCESS: {
            return {
                ...state,
                updatedCreditPolicy: action.payload,
                isUpdatingCreditPolicy: false,
                hasErrorUpdatedCreditPolicy: null
            }
        }
        case ACTIVATE_CREDIT_POLICY_FAILURE: {
            return {
                ...state,
                updatedCreditPolicy: null,
                isUpdatingCreditPolicy: false,
                hasErrorUpdatedCreditPolicy: action.payload
            }
        }

        // Delete Credit Policy
        case DELETE_CREDIT_POLICY_BEGIN: {
            return {
                ...state,
                isDeletingCreditPolicy: true
            }
        }
        case DELETE_CREDIT_POLICY_SUCCESS: {
            return {
                ...state,
                deletedCreditPolicy: action.payload,
                isDeletingCreditPolicy: false,
                hasErrorDeletedCreditPolicy: null
            }
        }
        case DELETE_CREDIT_POLICY_FAILURE: {
            return {
                ...state,
                deletedCreditPolicy: null,
                isDeletingCreditPolicy: false,
                hasErrorDeletedCreditPolicy: action.payload
            }
        }

        default: return state
    }
}

export default ReducerCreditPolicy